import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private sidenavToggleSubject = new Subject<void>();
  sidenavToggle$ = this.sidenavToggleSubject.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  toggle() {
    this.sidenavToggleSubject.next();
  }

  getDashboardWidgets(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + 'api/v1/admin/widget/counts', { withCredentials: true });
  }
}
